module.exports = "//static.hsappstatic.net/ContentComponents/static-2.71836/img/case-study-zero.png"